// extracted by mini-css-extract-plugin
export default {"SkeletonList":"SkeletonList--dMYeH","item":"item--SHqdU"};